import {store} from '../store';
import appConfig from '../config';
import {toast} from "react-toastify";

const request = method => {
    return (url, body = null) => {
        const requestOptions = {
            method,
            headers: authHeader(url),

        };
        // console.log(requestOptions)
        if (body) {
            requestOptions.headers['Content-Type'] = 'application/json';
            // requestOptions.headers['Access-Control-Allow-Origin'] = 'http://127.0.0.1:3000';
            requestOptions.headers['Access-Control-Allow-Origin'] = '*';
            // requestOptions.headers['Access-Control-Allow-Headers'] = '*';
            requestOptions.headers['Accept'] = 'application/json';
            requestOptions.body = JSON.stringify(body);
        }
        return fetch(url, requestOptions).then(handleResponse);
    }
}

// helper functions

const authHeader = url => {
    // return auth header with jwt if user is logged in and request is to the api url
    const token = authToken();
    console.log("fetch wrapper", token);
    const isLoggedIn = !!token;
    const isApiUrl = url.startsWith(appConfig.apiUrl);
    if (isLoggedIn && isApiUrl) {

        console.log("fetch wrapper", token);
        return { Authorization: `Bearer ${token}` };
    } else {
        return {};
    }
}

const authToken = () => {
    const token = store.getState().auth.token?.value 
    return token ? token : null
}

const handleResponse = response => {

    return response.text().then(text => {
        const data = text && JSON.parse(text);
        function isStartsWithFirstFigure(number, figure) {
            let str = number.toString(); // Convertir l'entier en chaîne de caractères
            return str[0] === figure.toString();
        }
        if (!response.ok || data.error) {
            const err = data.reason;

            if ([401, 403].includes(response.status) && authToken()) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                // store.dispatch(authActions.logout());
                // const logout2 = () => store.dispatch(userActions.logout());
                // const logout3 = () => store.dispatch(managerActions.logout());
                // const logout4 = () => store.dispatch(guestActions.logout());
                // logout();
                // logout2();
                // logout3();
                // logout4();
            }
            if (isStartsWithFirstFigure(response.status, 4)) {

                if (response.status === 400 && JSON.parse(err)){
                    const validations = JSON.parse(err)
                    Object.keys(validations).forEach(key => {
                        validations[key].map(val => {
                            if (val.includes('been taken')){
                                toast.error("L'email est deja pris")
                            } else if (val.includes('company.sub')){
                                toast.error('Sous catégorie est requise')
                            } else {
                                toast.error(val)
                            }
                        })
                    })
                } else {
                    toast.error(err)
                }
            }
            if (isStartsWithFirstFigure(response.status, 5)) {
                toast.error(err);
            }
            return Promise.reject(err);
        }
        //Toast('success', 'Well done!', 'tc', true, true, true, 4000);
        return data;
    });
}




export const fetchWrapper = {
    get: request('GET'),
    post: request('POST'),
    patch: request('PATCH'),
    put: request('PUT'),
    delete: request('DELETE')
};
